module.exports = __webpack_public_path__ + "img/will-icon.836c63a.svg";